import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import Actions from './ActionsComponent';

const CountdownModalComponent = ({ state, props }) => {
  const { secondsRemaining } = state;
  const {
    bodyText,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
    textToBeReplaced,
  } = props;

  const { t } = useTransl();

  let bodyTextForTimer = bodyText;
  if (textToBeReplaced) {
    const splittedTextForTimer = bodyText.split(textToBeReplaced);
    bodyTextForTimer =
      splittedTextForTimer[0] + secondsRemaining + splittedTextForTimer[1];
  }
  const actions = [
    {
      label: cancelText || t('common.no'),
      onClick: onCancel,
      color: 'primary',
    },
    {
      label: confirmText || t('modal.confirmText.yesSure'),
      onClick: onConfirm,
      color: 'secondary',
    },
  ];
  return (
    <>
      <Typography variant="body1" component="div">
        {bodyTextForTimer || t('modal.title.areYouSure')}
      </Typography>
      <Actions actions={actions} />
    </>
  );
};

CountdownModalComponent.defaultProps = {
  state: null,
  props: null,
};

CountdownModalComponent.propTypes = {
  state: PropTypes.shape({
    secondsRemaining: PropTypes.number.isRequired,
  }),

  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  bodyText: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  textToBeReplaced: PropTypes.string,
  props: PropTypes.instanceOf(Object),
};

export default CountdownModalComponent;
